module.exports = __webpack_public_path__ + "static/media/quieromibarrio.3c8f88d7.webp";